<template>
	<div :class="{'filler-block': isFillerBlock}" class="product-block" @[linkUrlEvent]="handleClick">
		<product-mask-overlay v-if="highlightResults && !isAdPage" v-bind="$props"/>
		<image-element v-else ref="imageElement" class="product-block-image" v-bind="$props"/>
		<div class="overlay"></div>
		<div v-if="isVisible">
			<product-click-regions
					v-for="(product, index) in products"
					:key="product.sku + index"
					:block="block"
					:block-data="blockData"
					:block-id="blockId"
					:hidePlayBtn="hidePlayBtn"
					:is-visible="isVisible"
					:is-in-viewport="isInViewport"
					:page="page"
					:product="product"
					v-on="$listeners"
			/>
			<item-highlight v-if="highlightEnabled" :block="block" :products="products"/>
		</div>

	</div>
</template>

<script>
import ImageElement from "@/components/block/elements/ImageElement.vue";
import ProductClickRegions from "@/components/block/elements/ProductClickRegions.vue";
import ProductMaskOverlay from "@/components/ProductMaskOverlay.vue";
import {mapGetters, mapActions} from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import ItemHighlight from "@/features/shopping-list/components/ItemHighlight.vue";


export default {
	name: "ProductElement",
	components: {ItemHighlight, ProductMaskOverlay, ProductClickRegions, ImageElement},
	props: {
		hidePlayBtn: {
			type: Boolean,
		},
		blockId: {
			type: String
		}
	},
	mixins: [blockElementMixin],
	mounted() {
		if (this.$parent.$options.name === "ProductBlockVideoElement") {
			this.getImageSrc();
		}
		if(this.isXRayEnabled) this.setProductRenderedData(this.renderedProductData)
	},
	computed: {
		...mapGetters(['highlightResults', 'isXRayEnabled']),
		...mapGetters('config', ['features']),
		...mapGetters('raddar', ['isRaddar']),
		products() {
			return this.blockData.products;
		},
		isAdPage() {
			return this.page.isAdPage;
		},
		isCarousel() {
			return (this.blockData?.carouselBlocks?.length ?? 0) >= 1;
		},
		isFillerBlock() {
			return this.blockData?.name?.includes('filler');
		},
		linkUrlEvent() {
			return this.blockData.linkUrl ? 'click' : 'null'
		},
		highlightEnabled(){

			//If no property was set for highlight config, get if its a raddar site and enable by default
			if (this.features?.shoppingList?.highlight?.enabled === undefined){
				return this.isRaddar;
			}

			return this.features?.shoppingList?.highlight?.enabled;
		},
		renderedProductData() {
			return {
				isFillerBlock: this.isFillerBlock,
			}
		}
	},
	methods: {
		...mapActions(['setProductRenderedData']),
		handleClick() {
			if (this.blockData.linkUrl) window.open(this.blockData.linkUrl)
		},
		async getImageSrc() {

			await this.$nextTick();
			const src = this.$refs.imageElement.src;
			this.$emit("srcFromProduct", src);
		}
	}
}
</script>

<style lang="scss">
.product-block {
  position: relative;

  &.filler-block {
	cursor: pointer;
  }
}

.flyer-block.ProductElement:not(.flyer-block.ProductElement.inblock) {
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

  &:hover, &:focus {
	transform: scale(1.02);
	box-shadow: 0 0px 50px rgba(0, 0, 0, 0.3);
	z-index: 9999;
	outline: none;
  }
}

.disable-popup .flyer-block.ProductElement:not(.flyer-block.ProductElement.inblock) {

	&:hover, &:focus {
	  transform: unset;
	  box-shadow: none;
	}
}

.overlay {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
}
</style>
